import(/* webpackMode: "eager", webpackExports: ["AppSidebarProvider"] */ "/app/apps/web/src/app/[locale]/(space)/components/sidebar/app-sidebar-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NavItem"] */ "/app/apps/web/src/app/[locale]/(space)/components/sidebar/nav-item.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NavUser"] */ "/app/apps/web/src/app/[locale]/(space)/components/sidebar/nav-user.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UpgradeButton"] */ "/app/apps/web/src/app/[locale]/(space)/components/upgrade-button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OptimizedAvatarImage"] */ "/app/apps/web/src/components/optimized-avatar-image.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/web/src/components/trans.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FeedbackToggle"] */ "/app/apps/web/src/features/feedback/components/feedback-toggle.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/web/src/features/navigation/command-menu/command-menu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TimezoneProvider"] */ "/app/apps/web/src/features/timezone/client/context.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.3.1_@babel+core@7.26.10_@opentelemetry+api@1.9.0_@playwright+test@1.52.0_react-_2336ead6c9af193fdc07ef65fb435775/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.3.1_@babel+core@7.26.10_@opentelemetry+api@1.9.0_@playwright+test@1.52.0_react-_2336ead6c9af193fdc07ef65fb435775/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/src/button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Icon"] */ "/app/packages/ui/src/icon.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/src/sidebar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Tooltip","TooltipTrigger","TooltipContent"] */ "/app/packages/ui/src/tooltip.tsx");
